import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 12l5 0","key":"svg-0"}],["path",{"d":"M15 12l5 0","key":"svg-1"}],["path",{"d":"M9 8a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2l0 -8","key":"svg-2"}]]

const IconLayoutAlignMiddle = createReactComponent('outline', 'layout-align-middle', 'LayoutAlignMiddle', __iconNode);

export default IconLayoutAlignMiddle;